// src/data/cancerCentersDirectoryData.js
// Complete Directory of all 72 NCI-Designated Cancer Centers + NAPT Proton Centers.

export const CANCER_CENTER_TECHNOLOGIES = [
  {
    key: 'proton',
    label: 'Proton Therapy',
    tag: 'NAPT Proton Center',
    description: 'Pencil-beam scanning proton radiation delivering concentrated dose directly to the tumor volume while sparing adjacent healthy organs and reducing secondary cancer risks.',
  },
  {
    key: 'cart',
    label: 'CAR-T Cell Therapy',
    tag: 'FDA CAR-T Certified',
    description: 'Chimeric Antigen Receptor (CAR) T-cell cellular immunotherapy genetically engineered to bind and destroy refractory leukemia, lymphoma, and multiple myeloma.',
  },
  {
    key: 'cyberknife',
    label: 'CyberKnife SBRT',
    tag: 'Sub-Millimeter SBRT',
    description: 'Robotic radiosurgery system delivering high-dose radiation to tumors in the brain, spine, lung, and prostate with real-time tumor tracking and motion synchronization.',
  },
  {
    key: 'robotic',
    label: 'Robotic Surgery',
    tag: 'da Vinci Xi Multiport',
    description: 'Minimally invasive computer-assisted oncologic surgery enabling precise tumor excisions, organ-sparing prostatectomies, and thoracic lobectomies with minimal blood loss.',
  },
  {
    key: 'phase1',
    label: 'Phase I Clinical Trials',
    tag: 'Experimental Therapeutics',
    description: 'Dedicated early-phase clinical trial units testing novel first-in-human targeted small molecules, bispecific antibodies, and personalized cancer vaccines.',
  },
];

export const NCI_CANCER_CENTERS = [
  {
    "slug": "abramson-cancer-center-university-of-pennsylvania",
    "name": "Abramson Cancer Center, University of Pennsylvania",
    "shortName": "Abramson Cancer Center, University",
    "city": "Philadelphia",
    "state": "Pennsylvania",
    "stateAbbr": "PA",
    "stateSlug": "pennsylvania",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.pennmedicine.org/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "CAR-T Cell Therapy Birthplace",
      "Proton Therapy",
      "Immunotherapy",
      "Breast & Ovarian Genetics (BRCA)"
    ],
    "hasProton": false,
    "description": "Abramson Cancer Center, University of Pennsylvania is a premier NCI-Designated Comprehensive Cancer Center located in Philadelphia, Pennsylvania. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "albert-einstein-cancer-center-montefiore",
    "name": "Albert Einstein Cancer Center (Montefiore)",
    "shortName": "Albert Einstein Cancer Center (Montefiore)",
    "city": "Bronx",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "111 E 210th St",
    "zip": "10467",
    "phone": "718-920-4826",
    "website": "https://www.einsteinmed.edu/centers/cancer",
    "clinicalTrialsCount": "300+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Stem Cell Biology",
      "Urban Health Disparities",
      "Surgical Oncology"
    ],
    "hasProton": false,
    "description": "Albert Einstein Cancer Center (Montefiore) is a premier NCI-Designated Comprehensive Cancer Center located in Bronx, New York. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "atrium-health-wake-forest-baptist-comprehensive-cancer-center",
    "name": "Atrium Health Wake Forest Baptist Comprehensive Cancer Center",
    "shortName": "Atrium Health Wake Forest Baptist Comprehensive Cancer Center",
    "city": "Winston-Salem",
    "state": "North Carolina",
    "stateAbbr": "NC",
    "stateSlug": "north-carolina",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "27157",
    "phone": "888-716-9283",
    "website": "https://www.wakehealth.edu",
    "clinicalTrialsCount": "350+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Brain & Spine Tumors",
      "Leukemia & Lymphoma",
      "Precision Radiation / Gamma Knife"
    ],
    "hasProton": false,
    "description": "Atrium Health Wake Forest Baptist Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Winston-Salem, North Carolina. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "barbara-ann-karmanos-cancer-institute",
    "name": "Barbara Ann Karmanos Cancer Institute",
    "shortName": "Barbara Ann Karmanos Cancer Institute",
    "city": "Detroit",
    "state": "Michigan",
    "stateAbbr": "MI",
    "stateSlug": "michigan",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "4100 John R St",
    "zip": "48201",
    "phone": "800-527-6266",
    "website": "https://www.karmanos.org",
    "clinicalTrialsCount": "300+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Phase I Clinical Trials",
      "Bone Marrow Transplant",
      "Urban Cancer Disparities",
      "Breast Oncology"
    ],
    "hasProton": false,
    "description": "Barbara Ann Karmanos Cancer Institute is a premier NCI-Designated Comprehensive Cancer Center located in Detroit, Michigan. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "case-comprehensive-cancer-center",
    "name": "Case Comprehensive Cancer Center",
    "shortName": "Case Comprehensive Cancer Center",
    "city": "Cleveland",
    "state": "Ohio",
    "stateAbbr": "OH",
    "stateSlug": "ohio",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://case.edu/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Immunotherapy",
      "Cancer Imaging",
      "Stem Cell Biology",
      "Translational Therapeutics"
    ],
    "hasProton": false,
    "description": "Case Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Cleveland, Ohio. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "chao-family-comprehensive-cancer-center-uc-irvine",
    "name": "Chao Family Comprehensive Cancer Center (UC Irvine)",
    "shortName": "Chao Family Comprehensive Cancer Center (UC Irvine)",
    "city": "Orange",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "101 The City Dr S",
    "zip": "92868",
    "phone": "714-456-8000",
    "website": "https://www.ucihealth.org/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Early Phase Clinical Trials",
      "Biophotonics",
      "Integrative Oncology"
    ],
    "hasProton": false,
    "description": "Chao Family Comprehensive Cancer Center (UC Irvine) is a premier NCI-Designated Comprehensive Cancer Center located in Orange, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "city-of-hope-comprehensive-cancer-center",
    "name": "City of Hope Comprehensive Cancer Center",
    "shortName": "City",
    "city": "Duarte",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1500 E Duarte Rd",
    "zip": "91010",
    "phone": "800-826-4673",
    "website": "https://www.cityofhope.org",
    "clinicalTrialsCount": "800+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Bone Marrow Transplant",
      "CAR-T Cell Therapy",
      "Immunotherapy",
      "Surgical Oncology"
    ],
    "hasProton": false,
    "description": "City of Hope Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Duarte, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "cleveland-clinic-taussig-cancer-institute",
    "name": "Cleveland Clinic Taussig Cancer Institute",
    "shortName": "Cleveland Clinic Taussig Cancer Institute",
    "city": "Cleveland",
    "state": "Ohio",
    "stateAbbr": "OH",
    "stateSlug": "ohio",
    "designation": "Leading Cancer Institute (Consortium Partner)",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://my.clevelandclinic.org/departments/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Proton Therapy",
      "Surgical Oncology",
      "Genitourinary Oncology",
      "Phase I Trials"
    ],
    "hasProton": false,
    "description": "Cleveland Clinic Taussig Cancer Institute is a premier Leading Cancer Institute (Consortium Partner) located in Cleveland, Ohio. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "cold-spring-harbor-laboratory-cancer-center",
    "name": "Cold Spring Harbor Laboratory Cancer Center",
    "shortName": "Cold Spring Harbor Laboratory",
    "city": "Cold Spring Harbor",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Basic Laboratory Cancer Center",
    "address": "1 Bungtown Rd",
    "zip": "11724",
    "phone": "516-367-8397",
    "website": "https://www.cancer.gov",
    "clinicalTrialsCount": "Basic Laboratory Discovery Program",
    "technologies": [
      "CRISPR Functional Genomics",
      "Organoid Drug Modeling"
    ],
    "keySpecialties": [
      "Basic Laboratory Cancer Research",
      "Translational Oncology",
      "Targeted Therapeutics Discovery"
    ],
    "hasProton": false,
    "description": "Cold Spring Harbor Laboratory Cancer Center is an NCI-Designated Basic Laboratory Cancer Center dedicated to foundational genetic, structural, and chemical oncology discoveries that fuel new cancer drug breakthroughs worldwide."
  },
  {
    "slug": "dan-l-duncan-comprehensive-cancer-center-at-baylor-college-of-medicine",
    "name": "Dan L Duncan Comprehensive Cancer Center at Baylor College of Medicine",
    "shortName": "Dan L Duncan Comprehensive Cancer Center",
    "city": "Houston",
    "state": "Texas",
    "stateAbbr": "TX",
    "stateSlug": "texas",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.bcm.edu/dan-l-duncan-comprehensive-cancer-center",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Breast Cancer Genetics",
      "Pediatric Oncology",
      "Immunotherapy"
    ],
    "hasProton": false,
    "description": "Dan L Duncan Comprehensive Cancer Center at Baylor College of Medicine is a premier NCI-Designated Comprehensive Cancer Center located in Houston, Texas. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "dana-farber-harvard-cancer-center",
    "name": "Dana-Farber / Harvard Cancer Center",
    "shortName": "Dana-Farber / Harvard Cancer Center",
    "city": "Boston",
    "state": "Massachusetts",
    "stateAbbr": "MA",
    "stateSlug": "massachusetts",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.dana-farber.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Precision Oncology",
      "CAR-T & Cellular Therapy",
      "Pediatric Oncology",
      "Breast & Thoracic Cancers"
    ],
    "hasProton": false,
    "description": "Dana-Farber / Harvard Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Boston, Massachusetts. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "dartmouth-cancer-center",
    "name": "Dartmouth Cancer Center",
    "shortName": "Dartmouth Cancer Center",
    "city": "Lebanon",
    "state": "New Hampshire",
    "stateAbbr": "NH",
    "stateSlug": "new-hampshire",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1 Medical Center Dr",
    "zip": "03756",
    "phone": "800-639-6918",
    "website": "https://cancer.dartmouth.edu",
    "clinicalTrialsCount": "200+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery"
    ],
    "keySpecialties": [
      "Immunotherapy",
      "Surgical Oncology",
      "Cancer Nanotechnology",
      "Rural Oncology"
    ],
    "hasProton": false,
    "description": "Dartmouth Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Lebanon, New Hampshire. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "duke-cancer-institute",
    "name": "Duke Cancer Institute",
    "shortName": "Duke Cancer Institute",
    "city": "Durham",
    "state": "North Carolina",
    "stateAbbr": "NC",
    "stateSlug": "north-carolina",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "20 Duke Medicine Cir",
    "zip": "27710",
    "phone": "888-275-3853",
    "website": "https://www.dukecancerinstitute.org",
    "clinicalTrialsCount": "750+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Brain Tumors (Preston Robert Tisch)",
      "Breast Cancer",
      "Immunotherapy",
      "Urologic Oncology"
    ],
    "hasProton": false,
    "description": "Duke Cancer Institute is a premier NCI-Designated Comprehensive Cancer Center located in Durham, North Carolina. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "fox-chase-cancer-center-temple-health",
    "name": "Fox Chase Cancer Center (Temple Health)",
    "shortName": "Fox Chase Cancer Center (Temple Health)",
    "city": "Philadelphia",
    "state": "Pennsylvania",
    "stateAbbr": "PA",
    "stateSlug": "pennsylvania",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.foxchase.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Urologic Oncology",
      "Gastrointestinal Cancers",
      "Genomics",
      "Radiation Oncology"
    ],
    "hasProton": false,
    "description": "Fox Chase Cancer Center (Temple Health) is a premier NCI-Designated Comprehensive Cancer Center located in Philadelphia, Pennsylvania. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "fred-pamela-buffett-cancer-center",
    "name": "Fred & Pamela Buffett Cancer Center",
    "shortName": "Fred & Pamela Buffett Cancer Center",
    "city": "Omaha",
    "state": "Nebraska",
    "stateAbbr": "NE",
    "stateSlug": "nebraska",
    "designation": "NCI-Designated Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.unmc.edu/cancercenter",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Lymphoma",
      "Leukemia & Stem Cell Transplant",
      "Pancreatic Cancer",
      "Genomics"
    ],
    "hasProton": false,
    "description": "Fred & Pamela Buffett Cancer Center is a premier NCI-Designated Cancer Center located in Omaha, Nebraska. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "fred-hutchinson-cancer-center",
    "name": "Fred Hutchinson Cancer Center",
    "shortName": "Fred Hutchinson Cancer Center",
    "city": "Seattle",
    "state": "Washington",
    "stateAbbr": "WA",
    "stateSlug": "washington",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1100 Fairview Ave N",
    "zip": "98109",
    "phone": "855-557-0555",
    "website": "https://www.fredhutch.org",
    "clinicalTrialsCount": "800+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Bone Marrow Transplant Birthplace",
      "Immunotherapy & CAR-T",
      "Precision Genomics",
      "Proton Therapy"
    ],
    "hasProton": true,
    "description": "Fred Hutchinson Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Seattle, Washington. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "georgetown-lombardi-comprehensive-cancer-center",
    "name": "Georgetown Lombardi Comprehensive Cancer Center",
    "shortName": "Georgetown Lombardi Comprehensive Cancer Center",
    "city": "Washington",
    "state": "Washington DC",
    "stateAbbr": "DC",
    "stateSlug": "washington-dc",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "3800 Reservoir Rd NW",
    "zip": "20007",
    "phone": "202-444-2223",
    "website": "https://www.lombardi.georgetown.edu",
    "clinicalTrialsCount": "350+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Breast Cancer",
      "Cancer Prevention",
      "Proton Therapy",
      "Immunotherapy"
    ],
    "hasProton": true,
    "description": "Georgetown Lombardi Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Washington, Washington DC. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "herbert-irving-comprehensive-cancer-center-columbia-university",
    "name": "Herbert Irving Comprehensive Cancer Center (Columbia University)",
    "shortName": "Herbert Irving Comprehensive Cancer Center (Columbia University)",
    "city": "New York City",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.cancer.columbia.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cancer Genomics",
      "Precision Oncology",
      "Breast & Prostate Cancers"
    ],
    "hasProton": false,
    "description": "Herbert Irving Comprehensive Cancer Center (Columbia University) is a premier NCI-Designated Comprehensive Cancer Center located in New York City, New York. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "huntsman-cancer-institute-at-the-university-of-utah",
    "name": "Huntsman Cancer Institute at the University of Utah",
    "shortName": "Huntsman Cancer Institute",
    "city": "Salt Lake City",
    "state": "Utah",
    "stateAbbr": "UT",
    "stateSlug": "utah",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://healthcare.utah.edu/huntsmancancerinstitute",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Hereditary Cancer Genetics",
      "Sarcoma",
      "Melanoma",
      "Proton Therapy",
      "Bone Marrow Transplant"
    ],
    "hasProton": false,
    "description": "Huntsman Cancer Institute at the University of Utah is a premier NCI-Designated Comprehensive Cancer Center located in Salt Lake City, Utah. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "indiana-university-melvin-and-bren-simon-comprehensive-cancer-center",
    "name": "Indiana University Melvin and Bren Simon Comprehensive Cancer Center",
    "shortName": "Indiana University Melvin and Bren Simon Comprehensive Cancer Center",
    "city": "Indianapolis",
    "state": "Indiana",
    "stateAbbr": "IN",
    "stateSlug": "indiana",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "535 Barnhill Dr",
    "zip": "46202",
    "phone": "888-600-4822",
    "website": "https://www.cancer.iu.edu",
    "clinicalTrialsCount": "450+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Testicular Cancer (World Pioneer)",
      "Breast Cancer / Triple-Negative",
      "Pancreatic Cancer",
      "Hematology"
    ],
    "hasProton": false,
    "description": "Indiana University Melvin and Bren Simon Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Indianapolis, Indiana. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "masonic-cancer-center-university-of-minnesota",
    "name": "Masonic Cancer Center, University of Minnesota",
    "shortName": "Masonic Cancer Center, University",
    "city": "Minneapolis",
    "state": "Minnesota",
    "stateAbbr": "MN",
    "stateSlug": "minnesota",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://cancer.umn.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Umbilical Cord Blood & Bone Marrow Transplant",
      "Immunotherapy",
      "Cancer Causes & Prevention"
    ],
    "hasProton": false,
    "description": "Masonic Cancer Center, University of Minnesota is a premier NCI-Designated Comprehensive Cancer Center located in Minneapolis, Minnesota. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "mayo-clinic-comprehensive-cancer-center",
    "name": "Mayo Clinic Comprehensive Cancer Center",
    "shortName": "Mayo Clinic Comprehensive Cancer Center",
    "city": "Rochester",
    "state": "Minnesota",
    "stateAbbr": "MN",
    "stateSlug": "minnesota",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.mayoclinic.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Multidisciplinary Team Care",
      "Proton Beam Therapy",
      "Surgical Innovation",
      "CAR-T Therapy",
      "Rare Cancers"
    ],
    "hasProton": false,
    "description": "Mayo Clinic Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Rochester, Minnesota. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "mayo-clinic-comprehensive-cancer-center---arizona",
    "name": "Mayo Clinic Comprehensive Cancer Center - Arizona",
    "shortName": "Mayo Clinic Comprehensive Cancer Center - Arizona",
    "city": "Phoenix",
    "state": "Arizona",
    "stateAbbr": "AZ",
    "stateSlug": "arizona",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "5777 E Mayo Blvd",
    "zip": "85054",
    "phone": "800-446-2279",
    "website": "https://www.mayoclinic.org",
    "clinicalTrialsCount": "350+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Proton Beam Therapy",
      "Surgical Oncology",
      "Neuro-Oncology",
      "CAR-T Therapy"
    ],
    "hasProton": true,
    "description": "Mayo Clinic Comprehensive Cancer Center - Arizona is a premier NCI-Designated Comprehensive Cancer Center located in Phoenix, Arizona. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "mayo-clinic-comprehensive-cancer-center---florida",
    "name": "Mayo Clinic Comprehensive Cancer Center - Florida",
    "shortName": "Mayo Clinic Comprehensive Cancer Center - Florida",
    "city": "Jacksonville",
    "state": "Florida",
    "stateAbbr": "FL",
    "stateSlug": "florida",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "4500 San Pablo Rd S",
    "zip": "32224",
    "phone": "904-953-2000",
    "website": "https://www.mayoclinic.org",
    "clinicalTrialsCount": "300+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Neuro-Oncology",
      "Proton & Carbon Ion Research",
      "Pancreatic Cancer"
    ],
    "hasProton": true,
    "description": "Mayo Clinic Comprehensive Cancer Center - Florida is a premier NCI-Designated Comprehensive Cancer Center located in Jacksonville, Florida. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "mays-cancer-center-at-ut-health-san-antonio",
    "name": "Mays Cancer Center at UT Health San Antonio",
    "shortName": "Mays Cancer Center",
    "city": "San Antonio",
    "state": "Texas",
    "stateAbbr": "TX",
    "stateSlug": "texas",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "7979 Wurzbach Rd",
    "zip": "78229",
    "phone": "210-450-1000",
    "website": "https://cancer.uthscsa.edu",
    "clinicalTrialsCount": "300+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Hispanic Cancer Health",
      "Breast Cancer Discovery",
      "Surgical Oncology"
    ],
    "hasProton": false,
    "description": "Mays Cancer Center at UT Health San Antonio is a premier NCI-Designated Comprehensive Cancer Center located in San Antonio, Texas. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "memorial-sloan-kettering-cancer-center-mskcc",
    "name": "Memorial Sloan Kettering Cancer Center (MSKCC)",
    "shortName": "Memorial Sloan Kettering Cancer Center (MSKCC)",
    "city": "New York City",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.mskcc.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Immunotherapy",
      "Surgical Oncology",
      "Rare Cancers",
      "Precision Medicine",
      "Pediatric Oncology"
    ],
    "hasProton": false,
    "description": "Memorial Sloan Kettering Cancer Center (MSKCC) is a premier NCI-Designated Comprehensive Cancer Center located in New York City, New York. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "moffitt-cancer-center",
    "name": "Moffitt Cancer Center",
    "shortName": "Moffitt Cancer Center",
    "city": "Tampa",
    "state": "Florida",
    "stateAbbr": "FL",
    "stateSlug": "florida",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "12902 USF Magnolia Dr",
    "zip": "33612",
    "phone": "888-663-3488",
    "website": "https://www.moffitt.org",
    "clinicalTrialsCount": "650+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "MR-Linac",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cellular Immunotherapy",
      "Cutaneous Oncology / Melanoma",
      "Thoracic Oncology",
      "Blood and Marrow Transplant"
    ],
    "hasProton": false,
    "description": "Moffitt Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Tampa, Florida. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "musc-hollings-cancer-center",
    "name": "MUSC Hollings Cancer Center",
    "shortName": "MUSC Hollings Cancer Center",
    "city": "Charleston",
    "state": "South Carolina",
    "stateAbbr": "SC",
    "stateSlug": "south-carolina",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://hollingscancercenter.musc.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Immunotherapy",
      "Surgical Oncology",
      "Cancer Disparities",
      "Blood & Marrow Transplant"
    ],
    "hasProton": false,
    "description": "MUSC Hollings Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Charleston, South Carolina. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "nyu-langone-perlmutter-cancer-center",
    "name": "NYU Langone Perlmutter Cancer Center",
    "shortName": "NYU Langone Perlmutter Cancer Center",
    "city": "New York City",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://nyulangone.org/locations/perlmutter-cancer-center",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Melanoma",
      "Thoracic Oncology",
      "Pancreatic Cancer",
      "Blood Malignancies"
    ],
    "hasProton": false,
    "description": "NYU Langone Perlmutter Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in New York City, New York. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "oneal-comprehensive-cancer-center-at-uab",
    "name": "O'Neal Comprehensive Cancer Center at UAB",
    "shortName": "O'Neal Comprehensive Cancer Center",
    "city": "Birmingham",
    "state": "Alabama",
    "stateAbbr": "AL",
    "stateSlug": "alabama",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1824 6th Ave S",
    "zip": "35233",
    "phone": "205-934-5077",
    "website": "https://www.uab.edu/onealcancercenter",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Phase I Clinical Trials",
      "Precision Oncology",
      "CAR-T Cell Therapy",
      "Hematologic Malignancies"
    ],
    "hasProton": false,
    "description": "O'Neal Comprehensive Cancer Center at UAB is a premier NCI-Designated Comprehensive Cancer Center located in Birmingham, Alabama. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "ohsu-knight-cancer-institute",
    "name": "OHSU Knight Cancer Institute",
    "shortName": "OHSU Knight Cancer Institute",
    "city": "Portland",
    "state": "Oregon",
    "stateAbbr": "OR",
    "stateSlug": "oregon",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "3485 S Bond Ave",
    "zip": "97239",
    "phone": "503-494-7999",
    "website": "https://www.ohsu.edu/knight-cancer-institute",
    "clinicalTrialsCount": "450+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Early Cancer Detection",
      "Precision Oncology",
      "Targeted Therapy (Gleevec)",
      "Hematology"
    ],
    "hasProton": false,
    "description": "OHSU Knight Cancer Institute is a premier NCI-Designated Comprehensive Cancer Center located in Portland, Oregon. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "purdue-institute-for-cancer-research",
    "name": "Purdue Institute for Cancer Research",
    "shortName": "Purdue Institute",
    "city": "West Lafayette",
    "state": "Indiana",
    "stateAbbr": "IN",
    "stateSlug": "indiana",
    "designation": "NCI-Designated Basic Laboratory Cancer Center",
    "address": "201 S University St",
    "zip": "47907",
    "phone": "765-494-9129",
    "website": "https://www.cancer.gov",
    "clinicalTrialsCount": "Basic Science & Drug Discovery",
    "technologies": [
      "Small-Molecule Drug Delivery",
      "Intraoperative Imaging Dyes"
    ],
    "keySpecialties": [
      "Basic Laboratory Cancer Research",
      "Translational Oncology",
      "Targeted Therapeutics Discovery"
    ],
    "hasProton": false,
    "description": "Purdue Institute for Cancer Research is an NCI-Designated Basic Laboratory Cancer Center dedicated to foundational genetic, structural, and chemical oncology discoveries that fuel new cancer drug breakthroughs worldwide."
  },
  {
    "slug": "robert-h-lurie-comprehensive-cancer-center-of-northwestern-university",
    "name": "Robert H. Lurie Comprehensive Cancer Center of Northwestern University",
    "shortName": "Robert H. Lurie Comprehensive Cancer Center",
    "city": "Chicago",
    "state": "Illinois",
    "stateAbbr": "IL",
    "stateSlug": "illinois",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.cancer.northwestern.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Precision Medicine",
      "Immunotherapy",
      "Surgical Oncology",
      "Hematologic Oncology"
    ],
    "hasProton": false,
    "description": "Robert H. Lurie Comprehensive Cancer Center of Northwestern University is a premier NCI-Designated Comprehensive Cancer Center located in Chicago, Illinois. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "roswell-park-comprehensive-cancer-center",
    "name": "Roswell Park Comprehensive Cancer Center",
    "shortName": "Roswell Park Comprehensive Cancer Center",
    "city": "Buffalo",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "665 Elm St",
    "zip": "14203",
    "phone": "800-767-9355",
    "website": "https://www.roswellpark.org",
    "clinicalTrialsCount": "450+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Immunotherapy",
      "Robotic Surgery",
      "Cellular Therapies",
      "Photodynamic Therapy"
    ],
    "hasProton": false,
    "description": "Roswell Park Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Buffalo, New York. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "rutgers-cancer-institute-of-new-jersey",
    "name": "Rutgers Cancer Institute of New Jersey",
    "shortName": "Rutgers Cancer Institute",
    "city": "New Brunswick",
    "state": "New Jersey",
    "stateAbbr": "NJ",
    "stateSlug": "new-jersey",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "195 Little Albany St",
    "zip": "08903",
    "phone": "844-226-2376",
    "website": "https://www.cinj.org",
    "clinicalTrialsCount": "500+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cellular Therapy & CAR-T",
      "Genomics",
      "Precision Radiation",
      "Pediatric Oncology"
    ],
    "hasProton": true,
    "description": "Rutgers Cancer Institute of New Jersey is a premier NCI-Designated Comprehensive Cancer Center located in New Brunswick, New Jersey. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "salk-institute-for-biological-studies",
    "name": "Salk Institute for Biological Studies",
    "shortName": "Salk Institute",
    "city": "La Jolla",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Basic Laboratory Cancer Center",
    "address": "10010 N Torrey Pines Rd",
    "zip": "92037",
    "phone": "858-453-4100",
    "website": "https://www.cancer.gov",
    "clinicalTrialsCount": "Basic Laboratory Discovery Program",
    "technologies": [
      "Targeted Drug Discovery",
      "Cryo-EM",
      "Translational Cancer Genetics"
    ],
    "keySpecialties": [
      "Basic Laboratory Cancer Research",
      "Translational Oncology",
      "Targeted Therapeutics Discovery"
    ],
    "hasProton": false,
    "description": "Salk Institute for Biological Studies is an NCI-Designated Basic Laboratory Cancer Center dedicated to foundational genetic, structural, and chemical oncology discoveries that fuel new cancer drug breakthroughs worldwide."
  },
  {
    "slug": "sanford-burnham-prebys-medical-discovery-institute",
    "name": "Sanford Burnham Prebys Medical Discovery Institute",
    "shortName": "Sanford Burnham Prebys Medical Discovery Institute",
    "city": "La Jolla",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Basic Laboratory Cancer Center",
    "address": "10901 N Torrey Pines Rd",
    "zip": "92037",
    "phone": "858-646-3100",
    "website": "https://www.cancer.gov",
    "clinicalTrialsCount": "Conrad Prebys Center for Chemical Genomics",
    "technologies": [
      "Chemical Genomics",
      "High-Throughput Drug Screening"
    ],
    "keySpecialties": [
      "Basic Laboratory Cancer Research",
      "Translational Oncology",
      "Targeted Therapeutics Discovery"
    ],
    "hasProton": false,
    "description": "Sanford Burnham Prebys Medical Discovery Institute is an NCI-Designated Basic Laboratory Cancer Center dedicated to foundational genetic, structural, and chemical oncology discoveries that fuel new cancer drug breakthroughs worldwide."
  },
  {
    "slug": "sidney-kimmel-cancer-center-at-jefferson",
    "name": "Sidney Kimmel Cancer Center at Jefferson",
    "shortName": "Sidney Kimmel Cancer Center",
    "city": "Philadelphia",
    "state": "Pennsylvania",
    "stateAbbr": "PA",
    "stateSlug": "pennsylvania",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.jeffersonhealth.org/clinical-specialties/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Prostate Cancer",
      "Precision Medicine",
      "Melanoma & Rare Tumors"
    ],
    "hasProton": false,
    "description": "Sidney Kimmel Cancer Center at Jefferson is a premier NCI-Designated Comprehensive Cancer Center located in Philadelphia, Pennsylvania. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "sidney-kimmel-comprehensive-cancer-center-at-johns-hopkins",
    "name": "Sidney Kimmel Comprehensive Cancer Center at Johns Hopkins",
    "shortName": "Sidney Kimmel Comprehensive Cancer Center",
    "city": "Baltimore",
    "state": "Maryland",
    "stateAbbr": "MD",
    "stateSlug": "maryland",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "401 N Broadway",
    "zip": "21231",
    "phone": "410-955-8964",
    "website": "https://www.hopkinsmedicine.org/kimmel_cancer_center",
    "clinicalTrialsCount": "750+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Immunotherapy Discovery",
      "Pancreatic Cancer",
      "Prostate Cancer",
      "Brain Tumors",
      "Pediatric Oncology"
    ],
    "hasProton": true,
    "description": "Sidney Kimmel Comprehensive Cancer Center at Johns Hopkins is a premier NCI-Designated Comprehensive Cancer Center located in Baltimore, Maryland. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "siteman-cancer-center",
    "name": "Siteman Cancer Center",
    "shortName": "Siteman Cancer Center",
    "city": "St. Louis",
    "state": "Missouri",
    "stateAbbr": "MO",
    "stateSlug": "missouri",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://siteman.wustl.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Proton Therapy",
      "Bone Marrow Transplant",
      "Genomics",
      "Phase I Clinical Trials"
    ],
    "hasProton": false,
    "description": "Siteman Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in St. Louis, Missouri. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "st-jude-childrens-research-hospital",
    "name": "St. Jude Children's Research Hospital",
    "shortName": "St. Jude Children's Research Hospital",
    "city": "Memphis",
    "state": "Tennessee",
    "stateAbbr": "TN",
    "stateSlug": "tennessee",
    "designation": "NCI-Designated Comprehensive Cancer Center (Pediatric)",
    "address": "262 Danny Thomas Pl",
    "zip": "38105",
    "phone": "866-278-5833",
    "website": "https://www.stjude.org",
    "clinicalTrialsCount": "350+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "Robotic Surgery",
      "Pediatric Phase I Unit"
    ],
    "keySpecialties": [
      "Pediatric Leukemia & Lymphoma",
      "Pediatric Brain Tumors",
      "Gene Therapy",
      "BMT"
    ],
    "hasProton": true,
    "description": "St. Jude Children's Research Hospital is a premier NCI-Designated Comprehensive Cancer Center (Pediatric) located in Memphis, Tennessee. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "stanford-cancer-institute",
    "name": "Stanford Cancer Institute",
    "shortName": "Stanford Cancer Institute",
    "city": "Palo Alto",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "875 Blake Wilbur Dr",
    "zip": "94304",
    "phone": "650-498-6000",
    "website": "https://med.stanford.edu/cancer.html",
    "clinicalTrialsCount": "750+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cancer Genomics",
      "Immunotherapy",
      "Precision Radiation",
      "Lymphoma"
    ],
    "hasProton": false,
    "description": "Stanford Cancer Institute is a premier NCI-Designated Comprehensive Cancer Center located in Palo Alto, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "stephenson-cancer-center-at-ou-health",
    "name": "Stephenson Cancer Center at OU Health",
    "shortName": "Stephenson Cancer Center",
    "city": "Oklahoma City",
    "state": "Oklahoma",
    "stateAbbr": "OK",
    "stateSlug": "oklahoma",
    "designation": "NCI-Designated Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.stephensoncancercenter.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Phase I Clinical Trials",
      "Gynecologic Oncology",
      "Proton Therapy",
      "Tobacco Research"
    ],
    "hasProton": false,
    "description": "Stephenson Cancer Center at OU Health is a premier NCI-Designated Cancer Center located in Oklahoma City, Oklahoma. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "sylvester-comprehensive-cancer-center-university-of-miami",
    "name": "Sylvester Comprehensive Cancer Center (University of Miami)",
    "shortName": "Sylvester Comprehensive Cancer Center (University",
    "city": "Miami",
    "state": "Florida",
    "stateAbbr": "FL",
    "stateSlug": "florida",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://umiamihealth.org/sylvester",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Epigenetics",
      "Precision Oncology",
      "Latin American Cancer Health Disparities",
      "Surgical Oncology"
    ],
    "hasProton": false,
    "description": "Sylvester Comprehensive Cancer Center (University of Miami) is a premier NCI-Designated Comprehensive Cancer Center located in Miami, Florida. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "the-james-cancer-hospital-and-solove-research-institute-osuccc",
    "name": "The James Cancer Hospital and Solove Research Institute (OSUCCC)",
    "shortName": "The James Cancer Hospital and Solove Research Institute (OSUCCC)",
    "city": "Columbus",
    "state": "Ohio",
    "stateAbbr": "OH",
    "stateSlug": "ohio",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://cancer.osu.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Leukemia & Hematology",
      "Precision Genetics",
      "CAR-T Therapy",
      "Thoracic Oncology"
    ],
    "hasProton": false,
    "description": "The James Cancer Hospital and Solove Research Institute (OSUCCC) is a premier NCI-Designated Comprehensive Cancer Center located in Columbus, Ohio. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "the-tisch-cancer-institute-at-mount-sinai",
    "name": "The Tisch Cancer Institute at Mount Sinai",
    "shortName": "The Tisch Cancer Institute",
    "city": "New York City",
    "state": "New York",
    "stateAbbr": "NY",
    "stateSlug": "new-york",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.mountsinai.org/care/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Liver Cancer (HCC)",
      "Multiple Myeloma",
      "Bladder Cancer",
      "CAR-T Therapy"
    ],
    "hasProton": false,
    "description": "The Tisch Cancer Institute at Mount Sinai is a premier NCI-Designated Comprehensive Cancer Center located in New York City, New York. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "the-university-of-kansas-cancer-center",
    "name": "The University of Kansas Cancer Center",
    "shortName": "The University",
    "city": "Kansas City",
    "state": "Kansas",
    "stateAbbr": "KS",
    "stateSlug": "kansas",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "2650 Shawnee Mission Pkwy",
    "zip": "66205",
    "phone": "913-588-1227",
    "website": "https://www.kucancercenter.org",
    "clinicalTrialsCount": "400+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Drug Discovery",
      "Bone Marrow Transplant",
      "Bladder & Urologic Cancers",
      "Immunotherapy"
    ],
    "hasProton": false,
    "description": "The University of Kansas Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Kansas City, Kansas. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "the-university-of-texas-md-anderson-cancer-center",
    "name": "The University of Texas MD Anderson Cancer Center",
    "shortName": "The University",
    "city": "Houston",
    "state": "Texas",
    "stateAbbr": "TX",
    "stateSlug": "texas",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.mdanderson.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "All Cancer Types",
      "Immunotherapy",
      "Proton Therapy",
      "Phase I Trials",
      "Surgical Oncology"
    ],
    "hasProton": false,
    "description": "The University of Texas MD Anderson Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Houston, Texas. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "uc-davis-comprehensive-cancer-center",
    "name": "UC Davis Comprehensive Cancer Center",
    "shortName": "UC Davis Comprehensive Cancer Center",
    "city": "Sacramento",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "2279 45th St",
    "zip": "95817",
    "phone": "800-770-9282",
    "website": "https://health.ucdavis.edu/cancer",
    "clinicalTrialsCount": "300+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Comparative Oncology",
      "Robotic Surgery",
      "Genitourinary Oncology"
    ],
    "hasProton": false,
    "description": "UC Davis Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Sacramento, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "uc-san-diego-moores-cancer-center",
    "name": "UC San Diego Moores Cancer Center",
    "shortName": "UC San Diego Moores Cancer Center",
    "city": "San Diego",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "3855 Health Sciences Dr",
    "zip": "92093",
    "phone": "858-822-6100",
    "website": "https://health.ucsd.edu/cancer",
    "clinicalTrialsCount": "400+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Personalized Medicine",
      "Surgical Oncology",
      "Proton Therapy",
      "GI Oncology"
    ],
    "hasProton": true,
    "description": "UC San Diego Moores Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in San Diego, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "ucla-jonsson-comprehensive-cancer-center",
    "name": "UCLA Jonsson Comprehensive Cancer Center",
    "shortName": "UCLA Jonsson Comprehensive Cancer Center",
    "city": "Los Angeles",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "100 Medical Plaza",
    "zip": "90095",
    "phone": "310-825-5268",
    "website": "https://cancer.ucla.edu",
    "clinicalTrialsCount": "600+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Targeted Therapy",
      "Melanoma & Immunotherapy",
      "Thoracic Oncology",
      "Gynecologic Oncology"
    ],
    "hasProton": false,
    "description": "UCLA Jonsson Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Los Angeles, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "ucsf-helen-diller-family-comprehensive-cancer-center",
    "name": "UCSF Helen Diller Family Comprehensive Cancer Center",
    "shortName": "UCSF Helen Diller Family Comprehensive Cancer Center",
    "city": "San Francisco",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1600 Divisadero St",
    "zip": "94115",
    "phone": "800-888-8664",
    "website": "https://cancer.ucsf.edu",
    "clinicalTrialsCount": "650+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Neuro-Oncology",
      "Prostate Cancer",
      "Breast Oncology",
      "Phase I Trials"
    ],
    "hasProton": false,
    "description": "UCSF Helen Diller Family Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in San Francisco, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "unc-lineberger-comprehensive-cancer-center",
    "name": "UNC Lineberger Comprehensive Cancer Center",
    "shortName": "UNC Lineberger Comprehensive Cancer Center",
    "city": "Chapel Hill",
    "state": "North Carolina",
    "stateAbbr": "NC",
    "stateSlug": "north-carolina",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "450 West Dr",
    "zip": "27599",
    "phone": "800-472-8228",
    "website": "https://unclineberger.org",
    "clinicalTrialsCount": "600+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cellular Immunotherapy / CAR-T",
      "Genomics",
      "Breast Cancer Subtyping",
      "Pediatric Oncology"
    ],
    "hasProton": false,
    "description": "UNC Lineberger Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Chapel Hill, North Carolina. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-arizona-cancer-center",
    "name": "University of Arizona Cancer Center",
    "shortName": "University",
    "city": "Tucson",
    "state": "Arizona",
    "stateAbbr": "AZ",
    "stateSlug": "arizona",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1515 N Campbell Ave",
    "zip": "85724",
    "phone": "520-694-2873",
    "website": "https://cancercenter.arizona.edu",
    "clinicalTrialsCount": "200+ Active Clinical Trials",
    "technologies": [
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "GI Cancers",
      "Skin Cancer / Melanoma",
      "Cancer Prevention",
      "Precision Medicine"
    ],
    "hasProton": false,
    "description": "University of Arizona Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Tucson, Arizona. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-chicago-comprehensive-cancer-center",
    "name": "University of Chicago Comprehensive Cancer Center",
    "shortName": "University",
    "city": "Chicago",
    "state": "Illinois",
    "stateAbbr": "IL",
    "stateSlug": "illinois",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://cancer.uchicago.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cellular Therapy / CAR-T",
      "Gastrointestinal Cancers",
      "Genomics",
      "Phase I Trials"
    ],
    "hasProton": false,
    "description": "University of Chicago Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Chicago, Illinois. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-colorado-cancer-center",
    "name": "University of Colorado Cancer Center",
    "shortName": "University",
    "city": "Aurora",
    "state": "Colorado",
    "stateAbbr": "CO",
    "stateSlug": "colorado",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1665 Aurora Ct",
    "zip": "80045",
    "phone": "720-848-0300",
    "website": "https://medschool.cuanschutz.edu/colorado-cancer-center",
    "clinicalTrialsCount": "350+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Thoracic Oncology",
      "Targeted Therapy (ALK/EGFR)",
      "Sarcoma",
      "Urologic Oncology"
    ],
    "hasProton": false,
    "description": "University of Colorado Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Aurora, Colorado. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-hawaii-cancer-center",
    "name": "University of Hawaii Cancer Center",
    "shortName": "University",
    "city": "Honolulu",
    "state": "Hawaii",
    "stateAbbr": "HI",
    "stateSlug": "hawaii",
    "designation": "NCI-Designated Cancer Center",
    "address": "701 Ilalo St",
    "zip": "96813",
    "phone": "808-586-3010",
    "website": "https://www.uhcancercenter.org",
    "clinicalTrialsCount": "150+ Active Clinical Trials",
    "technologies": [
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cancer Epidemiology",
      "Multi-Ethnic Health Research",
      "Clinical Trials Consortium"
    ],
    "hasProton": false,
    "description": "University of Hawaii Cancer Center is a premier NCI-Designated Cancer Center located in Honolulu, Hawaii. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-iowa-holden-comprehensive-cancer-center",
    "name": "University of Iowa Holden Comprehensive Cancer Center",
    "shortName": "University",
    "city": "Iowa City",
    "state": "Iowa",
    "stateAbbr": "IA",
    "stateSlug": "iowa",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://uihc.org/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Neuroendocrine Tumors (NETs)",
      "Free Radical Radiation Biology",
      "Sarcoma",
      "Stem Cell Transplant"
    ],
    "hasProton": false,
    "description": "University of Iowa Holden Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Iowa City, Iowa. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-kentucky-markey-cancer-center",
    "name": "University of Kentucky Markey Cancer Center",
    "shortName": "University",
    "city": "Lexington",
    "state": "Kentucky",
    "stateAbbr": "KY",
    "stateSlug": "kentucky",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://ukhealthcare.uky.edu/markey-cancer-center",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Lung Cancer",
      "Colorectal Cancer",
      "Appalachian Health Disparities",
      "Precision Oncology"
    ],
    "hasProton": false,
    "description": "University of Kentucky Markey Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Lexington, Kentucky. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-maryland-marlene-and-stewart-greenebaum-comprehensive-cancer-center",
    "name": "University of Maryland Marlene and Stewart Greenebaum Comprehensive Cancer Center",
    "shortName": "University",
    "city": "Baltimore",
    "state": "Maryland",
    "stateAbbr": "MD",
    "stateSlug": "maryland",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.umms.org/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Aromatase Inhibitor Research",
      "CAR-T Therapy",
      "Surgical Oncology",
      "Hematology"
    ],
    "hasProton": false,
    "description": "University of Maryland Marlene and Stewart Greenebaum Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Baltimore, Maryland. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-michigan-rogel-cancer-center",
    "name": "University of Michigan Rogel Cancer Center",
    "shortName": "University",
    "city": "Ann Arbor",
    "state": "Michigan",
    "stateAbbr": "MI",
    "stateSlug": "michigan",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1500 E Medical Center Dr",
    "zip": "48109",
    "phone": "800-865-1125",
    "website": "https://www.rogelcancercenter.org",
    "clinicalTrialsCount": "500+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cancer Genetics",
      "Endocrine Oncology",
      "Surgical Oncology",
      "Precision Immunotherapy"
    ],
    "hasProton": false,
    "description": "University of Michigan Rogel Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Ann Arbor, Michigan. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-new-mexico-comprehensive-cancer-center",
    "name": "University of New Mexico Comprehensive Cancer Center",
    "shortName": "University",
    "city": "Albuquerque",
    "state": "New Mexico",
    "stateAbbr": "NM",
    "stateSlug": "new-mexico",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1201 Camino de Salud NE",
    "zip": "87102",
    "phone": "505-272-4946",
    "website": "https://cancer.unm.edu",
    "clinicalTrialsCount": "200+ Active Clinical Trials",
    "technologies": [
      "Robotic Surgery",
      "CyberKnife SBRT",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Genomics",
      "Multi-Ethnic Cancer Biology",
      "Leukemia",
      "Phase I Clinical Trials"
    ],
    "hasProton": false,
    "description": "University of New Mexico Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Albuquerque, New Mexico. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "university-of-wisconsin-carbone-cancer-center",
    "name": "University of Wisconsin Carbone Cancer Center",
    "shortName": "University",
    "city": "Madison",
    "state": "Wisconsin",
    "stateAbbr": "WI",
    "stateSlug": "wisconsin",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://cancer.wisc.edu",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Precision Imaging (PET/CT)",
      "Immunotherapy",
      "Surgical Oncology",
      "Hematologic Malignancies"
    ],
    "hasProton": false,
    "description": "University of Wisconsin Carbone Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Madison, Wisconsin. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "upmc-hillman-cancer-center",
    "name": "UPMC Hillman Cancer Center",
    "shortName": "UPMC Hillman Cancer Center",
    "city": "Pittsburgh",
    "state": "Pennsylvania",
    "stateAbbr": "PA",
    "stateSlug": "pennsylvania",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "5115 Centre Ave",
    "zip": "15232",
    "phone": "412-647-2811",
    "website": "https://hillman.upmc.com",
    "clinicalTrialsCount": "600+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "MR-Linac",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Immunotherapy & Melanoma",
      "Surgical Oncology",
      "Cancer Virology",
      "Stereotactic Radiosurgery"
    ],
    "hasProton": false,
    "description": "UPMC Hillman Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Pittsburgh, Pennsylvania. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "usc-norris-comprehensive-cancer-center",
    "name": "USC Norris Comprehensive Cancer Center",
    "shortName": "USC Norris Comprehensive Cancer Center",
    "city": "Los Angeles",
    "state": "California",
    "stateAbbr": "CA",
    "stateSlug": "california",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1441 Eastlake Ave",
    "zip": "90033",
    "phone": "323-865-3000",
    "website": "https://www.cancer.keckmedicine.org",
    "clinicalTrialsCount": "350+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Urologic Oncology",
      "Epigenetics",
      "Colorectal Cancer"
    ],
    "hasProton": false,
    "description": "USC Norris Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Los Angeles, California. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "ut-southwestern-harold-c-simmons-comprehensive-cancer-center",
    "name": "UT Southwestern Harold C. Simmons Comprehensive Cancer Center",
    "shortName": "UT Southwestern Harold C. Simmons Comprehensive Cancer Center",
    "city": "Dallas",
    "state": "Texas",
    "stateAbbr": "TX",
    "stateSlug": "texas",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://utswmed.org/cancer",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Kidney Cancer",
      "Stereotactic Radiation",
      "Genomics",
      "Phase I Clinical Trials"
    ],
    "hasProton": false,
    "description": "UT Southwestern Harold C. Simmons Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Dallas, Texas. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "uva-comprehensive-cancer-center",
    "name": "UVA Comprehensive Cancer Center",
    "shortName": "UVA Comprehensive Cancer Center",
    "city": "Charlottesville",
    "state": "Virginia",
    "stateAbbr": "VA",
    "stateSlug": "virginia",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://uvahealth.com/services/cancer-care",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Focused Ultrasound",
      "Immunotherapy",
      "Melanoma",
      "Thoracic Oncology"
    ],
    "hasProton": false,
    "description": "UVA Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Charlottesville, Virginia. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "vanderbilt-ingram-cancer-center",
    "name": "Vanderbilt-Ingram Cancer Center",
    "shortName": "Vanderbilt-Ingram Cancer Center",
    "city": "Nashville",
    "state": "Tennessee",
    "stateAbbr": "TN",
    "stateSlug": "tennessee",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "2220 Pierce Ave",
    "zip": "37232",
    "phone": "800-811-8480",
    "website": "https://www.vicc.org",
    "clinicalTrialsCount": "600+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Precision Medicine",
      "Cancer Genomics",
      "Immunotherapy",
      "Surgical Oncology"
    ],
    "hasProton": true,
    "description": "Vanderbilt-Ingram Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Nashville, Tennessee. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "vcu-massey-comprehensive-cancer-center",
    "name": "VCU Massey Comprehensive Cancer Center",
    "shortName": "VCU Massey Comprehensive Cancer Center",
    "city": "Richmond",
    "state": "Virginia",
    "stateAbbr": "VA",
    "stateSlug": "virginia",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "401 College St",
    "zip": "23298",
    "phone": "804-828-5116",
    "website": "https://www.masseycancercenter.org",
    "clinicalTrialsCount": "300+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Community-Engaged Cancer Research",
      "Hematologic Oncology",
      "Cellular Therapy",
      "Surgical Oncology"
    ],
    "hasProton": false,
    "description": "VCU Massey Comprehensive Cancer Center is a premier NCI-Designated Comprehensive Cancer Center located in Richmond, Virginia. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "winship-cancer-institute-of-emory-university",
    "name": "Winship Cancer Institute of Emory University",
    "shortName": "Winship Cancer Institute",
    "city": "Atlanta",
    "state": "Georgia",
    "stateAbbr": "GA",
    "stateSlug": "georgia",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "1365 Clifton Rd NE",
    "zip": "30322",
    "phone": "888-946-7447",
    "website": "https://winshipcancer.emory.edu",
    "clinicalTrialsCount": "700+ Active Clinical Trials",
    "technologies": [
      "Proton Therapy",
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Multiple Myeloma",
      "Proton Therapy",
      "Lung Cancer",
      "Bone Marrow Transplant",
      "Phase I Trials"
    ],
    "hasProton": true,
    "description": "Winship Cancer Institute of Emory University is a premier NCI-Designated Comprehensive Cancer Center located in Atlanta, Georgia. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "winthrop-p-rockefeller-cancer-institute-uams",
    "name": "Winthrop P. Rockefeller Cancer Institute (UAMS)",
    "shortName": "Winthrop P. Rockefeller Cancer Institute (UAMS)",
    "city": "Little Rock",
    "state": "Arkansas",
    "stateAbbr": "AR",
    "stateSlug": "arkansas",
    "designation": "Major Academic Cancer Institute",
    "address": "4301 W Markham St",
    "zip": "72205",
    "phone": "501-686-8211",
    "website": "https://cancer.uams.edu",
    "clinicalTrialsCount": "180+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery"
    ],
    "keySpecialties": [
      "Multiple Myeloma",
      "Bone Marrow Transplant",
      "Surgical Oncology",
      "Hematologic Oncology"
    ],
    "hasProton": false,
    "description": "Winthrop P. Rockefeller Cancer Institute (UAMS) is a premier Major Academic Cancer Institute located in Little Rock, Arkansas. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  },
  {
    "slug": "yale-cancer-center-smilow-cancer-hospital",
    "name": "Yale Cancer Center / Smilow Cancer Hospital",
    "shortName": "Yale Cancer Center / Smilow Cancer Hospital",
    "city": "New Haven",
    "state": "Connecticut",
    "stateAbbr": "CT",
    "stateSlug": "connecticut",
    "designation": "NCI-Designated Comprehensive Cancer Center",
    "address": "Medical Center Blvd",
    "zip": "00000",
    "phone": "800-4-CANCER",
    "website": "https://www.yalecancercenter.org",
    "clinicalTrialsCount": "250+ Active Clinical Trials",
    "technologies": [
      "CAR-T Cell Therapy",
      "CyberKnife SBRT",
      "Robotic Surgery",
      "Phase I Unit"
    ],
    "keySpecialties": [
      "Cancer Immunology",
      "Melanoma",
      "Thoracic Oncology",
      "Genomics"
    ],
    "hasProton": false,
    "description": "Yale Cancer Center / Smilow Cancer Hospital is a premier NCI-Designated Comprehensive Cancer Center located in New Haven, Connecticut. It delivers cutting-edge multidisciplinary cancer treatment, early-phase clinical trial access, and pioneering oncologic research."
  }
];

export const NAPT_PROTON_CENTERS = [
  {
    "name": "MD Anderson Proton Therapy Center",
    "city": "Houston",
    "state": "TX",
    "stateSlug": "texas",
    "affiliation": "University of Texas MD Anderson Cancer Center"
  },
  {
    "name": "New York Proton Center",
    "city": "New York",
    "state": "NY",
    "stateSlug": "new-york",
    "affiliation": "Memorial Sloan Kettering, Mount Sinai, NYP-Columbia"
  },
  {
    "name": "Roberts Proton Therapy Center",
    "city": "Philadelphia",
    "state": "PA",
    "stateSlug": "pennsylvania",
    "affiliation": "Penn Medicine Abramson Cancer Center"
  },
  {
    "name": "Mass General Gordon Proton Center",
    "city": "Boston",
    "state": "MA",
    "stateSlug": "massachusetts",
    "affiliation": "Massachusetts General Hospital / Harvard"
  },
  {
    "name": "California Protons Cancer Therapy Center",
    "city": "San Diego",
    "state": "CA",
    "stateSlug": "california",
    "affiliation": "UC San Diego Moores Cancer Center"
  },
  {
    "name": "Emory Proton Therapy Center",
    "city": "Atlanta",
    "state": "GA",
    "stateSlug": "georgia",
    "affiliation": "Winship Cancer Institute of Emory University"
  },
  {
    "name": "Miami Cancer Institute Proton Therapy",
    "city": "Miami",
    "state": "FL",
    "stateSlug": "florida",
    "affiliation": "Baptist Health South Florida"
  },
  {
    "name": "UF Health Proton Therapy Institute",
    "city": "Jacksonville",
    "state": "FL",
    "stateSlug": "florida",
    "affiliation": "University of Florida Health"
  },
  {
    "name": "Northwestern Medicine Chicago Proton Center",
    "city": "Warrenville",
    "state": "IL",
    "stateSlug": "illinois",
    "affiliation": "Northwestern University Lurie Cancer Center"
  },
  {
    "name": "S. Lee Kling Proton Therapy Center",
    "city": "St. Louis",
    "state": "MO",
    "stateSlug": "missouri",
    "affiliation": "Siteman Cancer Center / Washington University"
  },
  {
    "name": "Fred & Pamela Buffett Proton Center",
    "city": "Omaha",
    "state": "NE",
    "stateSlug": "nebraska",
    "affiliation": "University of Nebraska Medical Center"
  },
  {
    "name": "Provision CARES Proton Therapy",
    "city": "Knoxville",
    "state": "TN",
    "stateSlug": "tennessee",
    "affiliation": "Provision Healthcare"
  },
  {
    "name": "Vanderbilt Proton Center",
    "city": "Nashville",
    "state": "TN",
    "stateSlug": "tennessee",
    "affiliation": "Vanderbilt-Ingram Cancer Center"
  },
  {
    "name": "Texas Oncology Proton Center",
    "city": "Irving",
    "state": "TX",
    "stateSlug": "texas",
    "affiliation": "The US Oncology Network / Baylor"
  },
  {
    "name": "Seattle Proton Therapy Center",
    "city": "Seattle",
    "state": "WA",
    "stateSlug": "washington",
    "affiliation": "Fred Hutchinson Cancer Center"
  },
  {
    "name": "Mayo Clinic Proton Beam Therapy - Rochester",
    "city": "Rochester",
    "state": "MN",
    "stateSlug": "minnesota",
    "affiliation": "Mayo Clinic Comprehensive Cancer Center"
  },
  {
    "name": "Mayo Clinic Proton Beam Therapy - Phoenix",
    "city": "Phoenix",
    "state": "AZ",
    "stateSlug": "arizona",
    "affiliation": "Mayo Clinic Comprehensive Cancer Center"
  },
  {
    "name": "Johns Hopkins Proton Center",
    "city": "Washington",
    "state": "DC",
    "stateSlug": "washington-dc",
    "affiliation": "Sibley Memorial Hospital / Johns Hopkins"
  },
  {
    "name": "Laurie Proton Therapy Center",
    "city": "New Brunswick",
    "state": "NJ",
    "stateSlug": "new-jersey",
    "affiliation": "Rutgers Cancer Institute of New Jersey"
  },
  {
    "name": "Arthur G. James Proton Center",
    "city": "Columbus",
    "state": "OH",
    "stateSlug": "ohio",
    "affiliation": "The Ohio State University Comprehensive Cancer Center"
  },
  {
    "name": "University of Cincinnati Proton Center",
    "city": "Cincinnati",
    "state": "OH",
    "stateSlug": "ohio",
    "affiliation": "UC Health & Cincinnati Children's"
  },
  {
    "name": "Huntsman Cancer Institute Proton Center",
    "city": "Salt Lake City",
    "state": "UT",
    "stateSlug": "utah",
    "affiliation": "Huntsman Cancer Institute at the Univ of Utah"
  },
  {
    "name": "St. Jude Red Frog Events Proton Therapy Center",
    "city": "Memphis",
    "state": "TN",
    "stateSlug": "tennessee",
    "affiliation": "St. Jude Children's Research Hospital"
  },
  {
    "name": "Maryland Proton Treatment Center",
    "city": "Baltimore",
    "state": "MD",
    "stateSlug": "maryland",
    "affiliation": "University of Maryland Greenebaum Cancer Center"
  },
  {
    "name": "Beaumont Proton Therapy Center",
    "city": "Royal Oak",
    "state": "MI",
    "stateSlug": "michigan",
    "affiliation": "Corewell Health"
  },
  {
    "name": "McLaren Proton Therapy Center",
    "city": "Flint",
    "state": "MI",
    "stateSlug": "michigan",
    "affiliation": "McLaren Health Care"
  },
  {
    "name": "Hampton University Proton Therapy Institute",
    "city": "Hampton",
    "state": "VA",
    "stateSlug": "virginia",
    "affiliation": "Hampton University"
  },
  {
    "name": "Inova Schar Cancer Institute Proton Center",
    "city": "Fairfax",
    "state": "VA",
    "stateSlug": "virginia",
    "affiliation": "Inova Health System"
  },
  {
    "name": "Stephenson Cancer Center Proton Center",
    "city": "Oklahoma City",
    "state": "OK",
    "stateSlug": "oklahoma",
    "affiliation": "Stephenson Cancer Center"
  },
  {
    "name": "Akron Children's Hospital Proton Center",
    "city": "Akron",
    "state": "OH",
    "stateSlug": "ohio",
    "affiliation": "Akron Children's Hospital"
  },
  {
    "name": "Dwight and Dian Diercks Proton Therapy Center",
    "city": "Milwaukee",
    "state": "WI",
    "stateSlug": "wisconsin",
    "affiliation": "Froedtert & Medical College of Wisconsin"
  }
];
